var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#FFC72B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#clip0_720_1084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0417 8H19.948C19.3138 8 18.7169 8.247 18.268 8.69588L16.8209 10.143C16.6712 10.2919 16.4725 10.375 16.2604 10.375H14.5417V9.58333C14.5417 9.14554 14.187 8.79167 13.75 8.79167C13.313 8.79167 12.9583 9.14554 12.9583 9.58333V10.375C10.7757 10.375 9 12.1507 9 14.3333V23.0417C9 25.2243 10.7757 27 12.9583 27H24.0417C26.2243 27 28 25.2243 28 23.0417V11.9583C28 9.77571 26.2243 8 24.0417 8ZM12.9583 11.9583H16.2604C16.8945 11.9583 17.4914 11.7113 17.9403 11.2625L19.3875 9.81529C19.5371 9.66646 19.7358 9.58333 19.948 9.58333H24.0417C25.3511 9.58333 26.4167 10.6489 26.4167 11.9583V17.5H23.1835C22.8059 15.2564 20.8497 13.5417 18.5 13.5417C16.1503 13.5417 14.1941 15.2564 13.8165 17.5H10.5833V14.3333C10.5833 13.0239 11.6489 11.9583 12.9583 11.9583ZM21.6667 18.2917C21.6667 20.0381 20.2464 21.4583 18.5 21.4583C16.7536 21.4583 15.3333 20.0381 15.3333 18.2917C15.3333 16.5452 16.7536 15.125 18.5 15.125C20.2464 15.125 21.6667 16.5452 21.6667 18.2917ZM24.0417 25.4167H12.9583C11.6489 25.4167 10.5833 24.3511 10.5833 23.0417V19.0833H13.8165C14.1941 21.3269 16.1503 23.0417 18.5 23.0417C20.8497 23.0417 22.8059 21.3269 23.1835 19.0833H26.4167V23.0417C26.4167 24.3511 25.3511 25.4167 24.0417 25.4167Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_720_1084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white",
    transform: "translate(9 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/cameraIcon.a8b3e085d4b45fb33cdd92162d952964.svg";
export { ForwardRef as ReactComponent };